import { shallowRef } from "vue";
import useAPIRequest from "@/composables/useAPIRequest";
import { ArticleDTO, ArticleModel } from "@/entities/Article";

const fetchArticleQuery = `
*[
  _type == 'article'
  && slug.current == $slug
  && !(_id in path("drafts.**"))
  && date <= now()
  && defined(image)
  && defined(title)
  && defined(body)
][0]
{
  _id,
  title,
  "slug": slug.current,
  date,
  "image": image.asset->url,
  body
}
`;

const article = shallowRef<ArticleModel | undefined>(undefined);

export default function useMedia() {
  const { fetch, requestState } = useAPIRequest<ArticleDTO>();
  const fetchArticle = async (slug: string) => {
    article.value = undefined;
    await fetch(fetchArticleQuery, { slug });
    if (requestState.value.status === "ready" && requestState.value.data) {
      article.value = new ArticleModel(requestState.value.data);
    }
  };

  return {
    fetchArticle,
    article,
    requestState,
  };
}
